import Transformer from "./../transformer";
import moment from "moment";

export default class ExpectedTransformer extends Transformer {
  static fetch(expected) {
    let affected = expected.affected || {};
    affected = {
      id: affected.id,
      requisitionNumber: affected.requisition_number,
      sinisterNumber: affected.sinister_number,
      sinisterId: affected.sinister_id,
      roadSinisterId: affected.road_sinister_id,
      highwayId: affected.highway_id,
      highwayName: affected.highway_name,

      requiredGO: affected.required_go,
      requiredBTC: affected.required_btc,
      requiredFDP: affected.required_fdp,
    };
    return {
      id: expected.id,
      affected,
      affectedId: affected.id,
      sinisterId: affected.sinisterId,
      roadSinisterId: affected.roadSinisterId,
      sinisterNumber: affected.sinisterNumber,
      highwayId: affected.highwayId,
      highwayName: affected.highwayName,
      approved: expected.approved,
      startDate: expected.start_date,
      finishDate: expected.finish_date,
      status: expected.status,
      dateObjects: {
        startDate: moment(expected.start_date),
        finishDate: moment(expected.finish_date),
      },
      isMarkedToReview: expected.is_mark_to_review,
    };
  }

  static send(workPlan) {
    let sinisters = [];

    for (let el in workPlan) {
      let obj = workPlan[el];

      sinisters.push({
        affected: el,
        start_date: obj.start,
        finish_date: obj.end,
        resident: obj.resident,
      });
    }

    return { sinisters };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/workPlan/expected.js